import type {
  ConfigurationResourceSnapshotApplicationItemBffV2Api,
  ConfigurationResourceSnapshotReadBffV2Api,
  ConfigurationResourceSnapshotSystemPackageItemBffV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { enumConfigurationResourceSoftwareItemV2 } from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type { ConfigurationResourceFront, ModuleItemField } from '../../models/snapshot.model';
import { ModuleType } from '../../models/snapshot.model';

export function mapGetConfigurationSnapshotById({
  definition: {
    configuration: { osVersion, systemPackageVersions, remoteKeyInjection, applicationVersions },
  },
  description,
  name,
  creationDate,
  creator,
  id,
  updateDate,
  updatedBy,
}: ConfigurationResourceSnapshotReadBffV2Api): ConfigurationResourceFront {
  return {
    definition: {
      configuration: {
        applicationVersions:
          applicationVersions?.map((app) => ({
            ...app,
            configurationModuleName: toString(app.configurationModuleName),
          })) ?? [],
        osVersion: osVersion
          ? {
              id: osVersion.id,
              osId: osVersion.osId,
              osLogo: osVersion.osLogo,
              osName: osVersion.osName,
              osVersionId: osVersion.osVersionId,
              osVersionNumber: osVersion.osVersionNumber,
            }
          : undefined,
        remoteKeyInjection: remoteKeyInjection ? remoteKeyInjection.map((rkiName) => ({ name: rkiName })) : undefined,
        systemPackageVersions:
          systemPackageVersions?.map((sp) => ({
            ...sp,
            configurationModuleName: toString(sp.configurationModuleName),
          })) ?? [],
      },
      compositions: [],
    },
    description,
    name,
    creationDate,
    creator,
    id,
    updateDate,
    updatedBy,
  };
}

export function filterApplicationVersionsByType({
  type,
}: ConfigurationResourceSnapshotApplicationItemBffV2Api): boolean {
  return type === enumConfigurationResourceSoftwareItemV2.CONFIGURATION_MODULE;
}
export function filterSystemPackageVersionByType({
  type,
}: ConfigurationResourceSnapshotSystemPackageItemBffV2Api): boolean {
  return type === enumConfigurationResourceSoftwareItemV2.CONFIGURATION_MODULE;
}

export function mapFromConfigurationResourceSnapshotApplicationItemBffV2ApiToModuleItemFields({
  applicationLogo,
  applicationName,
  configurationModuleName,
  applicationVersionNumber,
  configurationModuleSnapshotId,
  applicationVersionId,
}: ConfigurationResourceSnapshotApplicationItemBffV2Api): ModuleItemField {
  return {
    name: applicationName,
    module: configurationModuleName,
    version: applicationVersionNumber,
    configurationModuleId: toString(configurationModuleSnapshotId),
    sourceType: ModuleType.APPLICATION,
    templateRequestId: applicationVersionId,
    logoAssetId: toString(applicationLogo.id),
  };
}
export function mapFromConfigurationResourceSnapshotSystemPackageItemBffV2ApiToModuleItemFields({
  systemPackageLogo,
  systemPackageName,
  configurationModuleName,
  systemPackageVersionNumber,
  configurationModuleSnapshotId,
  systemPackageVersionId,
}: ConfigurationResourceSnapshotSystemPackageItemBffV2Api): ModuleItemField {
  return {
    name: systemPackageName,
    module: configurationModuleName,
    version: systemPackageVersionNumber,
    configurationModuleId: toString(configurationModuleSnapshotId),
    sourceType: ModuleType.SYSTEM_PACKAGE,
    templateRequestId: systemPackageVersionId,
    logoAssetId: toString(systemPackageLogo.id),
  };
}

export function mapParameterOutputList({
  definition: {
    configuration: { applicationVersions, systemPackageVersions },
  },
}: Pick<ConfigurationResourceSnapshotReadBffV2Api, 'definition'>): ModuleItemField[] {
  const moduleItemForApplications = applicationVersions
    .filter(filterApplicationVersionsByType)
    .map(mapFromConfigurationResourceSnapshotApplicationItemBffV2ApiToModuleItemFields);
  const moduleItemForSystemPackageVersions = systemPackageVersions
    .filter(filterSystemPackageVersionByType)
    .map(mapFromConfigurationResourceSnapshotSystemPackageItemBffV2ApiToModuleItemFields);

  return [...moduleItemForApplications, ...moduleItemForSystemPackageVersions];
}
